import { isString } from 'lodash';

export type Action<T> = {
  [K in keyof T]: {
    type: K;
    payload: T[K];
  };
}[keyof T];

export type ActionType<T> = Action<T> | Action<T>[];
export const useReducerStore = <T extends Record<keyof T, unknown>>(originState: T) => {
  const reducer = (state: T, action: ActionType<T>): T => {
    const actionArr = Array.isArray(action) ? action : [action];
    const updates = actionArr.reduce((acc, item) => {
      return {
        ...acc,
        [item.type]: isString(item.payload) ? item.payload.trim() : item.payload,
      };
    }, {} as Partial<T>);
    return {
      ...state,
      ...updates,
    };
  };

  const [state, dispatch] = useReducer(reducer, originState);

  return { state, dispatch };
};
